import { Button, Switch } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import config from '../../../utils/config';

export default function SwitchProductMode({
	vatKeys,
	onSave,
	deleteLinkByType,
	disabled,
	isMaster,
}) {
	const onChange = value => {
		if (
			window.confirm(
				'Êtes-vous sûr de vouloir changer de mode de répartition ? Cela supprimera toutes les liaisons sur les comptes pour les produits'
			)
		) {
			deleteLinkByType('product');
			onSave({
				...vatKeys,
				account_vat_product_mode: value,
			});
		}
	};

	const styleSpan = { opacity: disabled ? 0.5 : 1 };

	return (
		<div style={{ marginLeft: 20, marginBottom: 10 }}>
			<span style={styleSpan}>
				Mode de répartition des produits : Type de produit (par défaut)
			</span>
			<Switch
				checked={vatKeys['account_vat_product_mode'] == 'tag'}
				onChange={e => onChange(e.target.checked ? 'tag' : 'productType')}
				disabled={disabled}
			/>
			<span style={styleSpan}>Familles</span>

			{!isMaster ? (
				<a
					target="blank"
					href={config.formTagProduct}
					style={{ marginLeft: 10 }}>
					<Button variant="contained" color="secondary">
						Gestion des familles{' '}
					</Button>
				</a>
			) : null}
		</div>
	);
}
